export const state = {
  isLoading: false,
  loadingCount: 0,
};

export default state;
